// This file was generated using `pay js:run gql-v1 --type=lazy-query --name=RetrieveAuthenticatedUser --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1LazyQueryOptionsWithoutVariables,
  V1LazyQueryOptions,
  V1LazyQueryReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1LazyQuery} from '@stripe-internal/data-v1';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1ConnectUserInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

import {authenticatedUserFragment} from './authenticatedUserFragment';

import type {AuthenticatedUserFragmentData} from './authenticatedUserFragment';

const doc = gql`
  query RetrieveAuthenticatedUserQuery(
    $input: OpenapiGetV1ConnectUserInput
    $v1Context: V1ContextInput!
  ) {
    v1ConnectUser(input: $input, v1Context: $v1Context) {
      id
      ...AuthenticatedUserFragment
    }
  }

  ${authenticatedUserFragment}
`;

export const retrieveAuthenticatedUserLazyQuery: RetrieveAuthenticatedUserLazyQueryDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const retrieveAuthenticatedUserLazyQueryOptions: V1LazyQueryOptionsWithoutVariables<RetrieveAuthenticatedUserLazyQueryDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useRetrieveAuthenticatedUserLazyQuery(
  options: V1LazyQueryOptions<RetrieveAuthenticatedUserLazyQueryDocument> = {},
): V1LazyQueryReturn<RetrieveAuthenticatedUserLazyQueryDocument> {
  return useV1LazyQuery(
    retrieveAuthenticatedUserLazyQuery,
    Object.assign({}, retrieveAuthenticatedUserLazyQueryOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetrieveAuthenticatedUserLazyQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1ConnectUserInput>;
  v1Context: V1ContextInput;
}>;

export type RetrieveAuthenticatedUserLazyQueryData = {
  readonly __typename: 'Query';
  readonly v1ConnectUser: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiConnectAuthResourcesUser';
      readonly id: string;
    },
    [AuthenticatedUserFragmentData]
  > | null;
};

const retrieveAuthenticatedUserLazyQueryPermissions = {
  ...authenticatedUserFragment.permissions,
} as const;

doc.permissions = retrieveAuthenticatedUserLazyQueryPermissions;

export type RetrieveAuthenticatedUserLazyQueryPermissions = V1PermissionToken<
  typeof retrieveAuthenticatedUserLazyQueryPermissions
>;

export type RetrieveAuthenticatedUserLazyQueryDocument = GraphQlDocument<
  RetrieveAuthenticatedUserLazyQueryData,
  RetrieveAuthenticatedUserLazyQueryVariables,
  RetrieveAuthenticatedUserLazyQueryPermissions
>;
